import React from 'react';

const TagIcon = ({ className, style }) => {
  return (
    <svg
      width="20"
      height="14"
      viewBox="0 0 20 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M1 11V3C1 1.89543 1.89543 1 3 1H14.2825C14.8936 1 15.4712 1.27943 15.8506 1.75859L19.0172 5.75859C19.5931 6.48602 19.5931 7.51398 19.0172 8.24141L15.8506 12.2414C15.4712 12.7206 14.8936 13 14.2825 13H3C1.89543 13 1 12.1046 1 11Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default TagIcon;
